<template>
  <div :class="{
    'map-overlay': true,
    'map-overlay--hidden': !getOverlayOpen,
  }">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
// import { LoremIpsum } from 'lorem-ipsum';

import useOverlay from '@/components/composers/useOverlay';

const MapOverlay: object = defineComponent({
  name: 'MapOverlay',
  setup() {
    // const title = computed(() => {
    //   const lorem = new LoremIpsum();
    //   return lorem.generateWords(3);
    // });
    // const paragraph = computed(() => {
    //   const lorem = new LoremIpsum();
    //   let content = '';
    //   for (let i = 0; i < 20; i += 1) {
    //     content += `<p>${lorem.generateParagraphs(1)}</p>`;
    //   }
    //   return content;
    // });
    return {
      // title,
      // paragraph,
      ...useOverlay(),
    };
  },
});
export default MapOverlay;
</script>

<style scoped lang="scss">
  @import "~sass-rem";
  .map-overlay{
    height: 100%;
    width: 100%;
    background: rgba(255,255,255, 0.88);
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 2;
    transition: opacity ease-in-out 0.2s;
    opacity: 1;
    &--hidden{
      opacity: 0;
      pointer-events: none;
    }
    &__container{
      max-width: rem(820px);
      margin: 0 auto;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    &__header{
      text-align: center;
      display: block;
      font: Bold 18px/17px Roboto;
      letter-spacing: 0.79px;
      color: #000000;
      text-transform: uppercase;
      opacity: 1;
      padding-top: rem(30px);
      padding-bottom: rem(25px);
      padding-left: rem(15px);
      padding-right: rem(15px);
      border-bottom: 1px solid #285397;
      flex-grow: 0;
    }
    &__content{
      padding: rem(25px);
      overflow-y: scroll;
      flex-grow: 1;
      box-sizing: border-box;
      height: 100%;
    }
  }
</style>
